import ccEmailImport from './ccEmail'

export const ccEmail = ccEmailImport

export const getCcEmailLinkManual = state => {
  return state.link_manual
}



// WEBPACK FOOTER //
// ./src/store/modules/cc_emails/getters/index.js